import type { StateCreator } from 'zustand';
import type { ItineraryState } from '../itinerary-store';
import { markTripDirty } from '../sync-bridge';

export interface DaySlice {
  removeDay: (tripId: string, dayId: string) => void;
  updateDayLabel: (tripId: string, dayId: string, label: string) => void;
}

export const createDaySlice: StateCreator<ItineraryState, [], [], DaySlice> = (set, get) => ({
  removeDay: (tripId, dayId) => {
    get()._capture();
    set((s) => {
      const trip = s.trips.find((t) => t.id === tripId);
      if (!trip || trip.days.length <= 1) return s;
      const newDays = trip.days.filter((d) => d.id !== dayId);
      if (newDays.length === trip.days.length) return s;
      const startDate = newDays[0]?.date ?? trip.startDate;
      const endDate = newDays[newDays.length - 1]?.date ?? trip.endDate;
      return {
        trips: s.trips.map((t) =>
          t.id === tripId
            ? { ...t, days: newDays, startDate, endDate }
            : t
        ),
      };
    });
    markTripDirty(tripId, ['days']);
  },

  updateDayLabel: (tripId, dayId, label) => {
    const value = label.trim() || undefined;
    set((s) => ({
      trips: s.trips.map((t) => {
        if (t.id !== tripId) return t;
        return {
          ...t,
          days: t.days.map((d) =>
            d.id === dayId ? { ...d, label: value } : d
          ),
        };
      }),
    }));
    markTripDirty(tripId, ['days']);
  },
});
